/* CAMPAIGN*/
export const GET_CAMPAIGN = "GET_CAMPAIGN"
export const SET_CAMPAIGN = "SET_CAMPAIGN"
export const SET_CAMPAIGN_ERROR = "SET_CAMPAIGN_ERROR"

/* CAMPAIGN CLIENTS */
export const GET_CAMPAIGN_CLIENTS_PROFILE_LIST = "GET_CAMPAIGN_CLIENTS_PROFILE_LIST"
export const SET_CAMPAIGN_CLIENTS_PROFILE_LIST = "SET_CAMPAIGN_CLIENTS_PROFILE_LIST"

/* CAMPAIGN APPLICATIONS */
export const GET_CAMPAIGN_APPLICATIONS_PROFILE_LIST = "GET_CAMPAIGN_APPLICATIONS_PROFILE_LIST"
export const SET_CAMPAIGN_APPLICATIONS_PROFILE_LIST = "SET_CAMPAIGN_APPLICATIONS_PROFILE_LIST"

/* CAMPAIGN OFFER TYPE */
export const GET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST = "GET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST"
export const SET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST = "SET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST"

/* CAMPAIGN SOURCE */
export const GET_CAMPAIGN_SOURCE_PROFILE_LIST = "GET_CAMPAIGN_SOURCE_PROFILE_LIST"
export const SET_CAMPAIGN_SOURCE_PROFILE_LIST = "SET_CAMPAIGN_SOURCE_PROFILE_LIST"

/* CAMPAIGN DIRECTION TYPE */
export const GET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST = "GET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST"
export const SET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST = "SET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST"

/* CAMPAIGN STATUS */
export const GET_CAMPAIGN_STATUS_PROFILE_LIST = "GET_CAMPAIGN_STATUS_PROFILE_LIST"
export const SET_CAMPAIGN_STATUS_PROFILE_LIST = "SET_CAMPAIGN_STATUS_PROFILE_LIST"

/* CAMPAIGN MEDIA BUYER */
export const GET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST = "GET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST"
export const SET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST = "SET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST"

/* CAMPAIGN FORMAT */
export const GET_CAMPAIGN_FORMAT_PROFILE_LIST = "GET_CAMPAIGN_FORMAT_PROFILE_LIST"
export const SET_CAMPAIGN_FORMAT_PROFILE_LIST = "SET_CAMPAIGN_FORMAT_PROFILE_LIST"

/* CAMPAIGN UPDATE */
export const UPDATE_CAMPAIGN_PROFILE = "UPDATE_CAMPAIGN_PROFILE"